import { useEffect } from 'react';
import { TsoPlatformIds } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useTsoPlatformIds(uuid: string) {
  const tso = useAxios(
    (axios, signal, uuid: string) =>
      axios.request<TsoPlatformIds>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/tso/platform-ids/${uuid}`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    tso.execute(uuid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  return tso;
}

export type TsoPlatformIdsRequest = ReturnType<typeof useTsoPlatformIds>;
